// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__eA30F","consentsList":"PatientConsents_consentsList__y5OxR","consentsListEmpty":"PatientConsents_consentsListEmpty__2-4_l"};